import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardFilterBridgeComponent } from './dashboard-filter-bridge.component';
import { DashboardSiteSelectorBridgeComponent } from './dashboard-site-selector-bridge.component';
import { TuhonoFilterBridgeComponent } from './tuhono-filter-bridge.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DashboardFilterBridgeComponent, DashboardSiteSelectorBridgeComponent, TuhonoFilterBridgeComponent],
  exports: [DashboardFilterBridgeComponent, DashboardSiteSelectorBridgeComponent, TuhonoFilterBridgeComponent],
})
export class FilterPanelModule {}
